import React from 'react';
import { Link } from 'react-router-dom';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as SVGICONS from '../../images/img/images';
// import * as signinActions from '../../actions/signinActions';
// import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as documentActions from '../../actions/documentUploadActions';
import * as constant from '../../constants/constant';
import {
	Modal,
} from 'react-bootstrap';
import classNames from 'classnames';
import validator from '../common/validator';
const autoBind = require('auto-bind');
//login container component
class Signin extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			appointmentId: this.props.appointmentId,
			doctorId: this.props.doctorId,

			patientId: this.props.patientId,
			appointmentDocument: [],
		};
	}

	componentWillMount() {
		let appointmentObj = {
			appointmentId: this.state.appointmentId,
		};
		let doctorObj = {
			userId: this.state.doctorId
		}
		if (appointmentObj.appointmentId != undefined) {
			this.props.documentactions.getAppointmentDocument(appointmentObj);
		}
		if (doctorObj.userId != undefined) {
			this.props.documentactions.getSpecialistDocument(doctorObj);
		}
	}

	componentWillReceiveProps(nextProps) {

		console.log('data ', nextProps);
		this.setState({
			appointmentDocument: nextProps.appointmentDocument
		})
	}

	render() {
		var appointmentDocument = this.state.appointmentDocument;
		var rows = [];
		{ appointmentDocument.length }
		{
			appointmentDocument && appointmentDocument.length > 0 ? appointmentDocument.forEach(function (item, index) {
				var documentpath = /* constant.PRODUCTION_IMAGE_URL +  */'/uploads/' + this.state.patientId + '/' + item.documentUrl;
				rows.push(<tr key={index}>
					<td>
						{item.documentName}
					</td>
					<td> <Link to={documentpath} target="_blank">{item.documentOriginalName}</Link>
					</td>
				</tr>)
			}.bind(this)) : rows.push(<tr><td colSpan="2" style={{ 'textAlign': 'center' }}>No Uploaded Documents</td></tr>)
		}

		return (
			<Modal show={this.props.openModal} size="modal-sm" onHide={this.props.hideConditionModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideConditionModal} /> */}
					<div className="signIn">Uploaded Documents</div>
				</Modal.Header>
				<Modal.Body>
					<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
						<div className="table-responsive">
							<table className="table table-striped table-bordered table-hover">
								<thead>
									<tr>
										<th>
											Document Name
								</th>
										<th>
											Document
								</th>
									</tr>
								</thead>
								<tbody>{rows}</tbody>
							</table>
						</div></div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		appointmentDocument: state.uploadDocument.uploadedImages ? state.uploadDocument.uploadedImages : ''
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		documentactions: bindActionCreators(documentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Signin);
